export const AVAILABILITY_SETTINGS_CHANGE = 'availability_change';
